import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { logout, getAccesstoken, getUserId } from "../../utils/auth";
import { getCartItemCount } from "../../api/utils";
import ReducarbLogo from "../../UserAssets/reducarb_logo.png"

const Navbar = () => {
  const location = useLocation();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const access_token = getAccesstoken();
  const [cartCount, setCartCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const user_id = getUserId();

  useEffect(() => {
    // Close the mobile navbar and clean up backdrops on route change
    const offcanvasElement = document.getElementById("primaryMenu");
    const backdrops = document.querySelectorAll(".offcanvas-backdrop");

    if (offcanvasElement && offcanvasElement.classList.contains("show")) {
      offcanvasElement.classList.remove("show");
      document.body.classList.remove("offcanvas-backdrop");
      document.body.style.overflow = ""; // Restore body scroll if disabled
    }

    backdrops.forEach((backdrop) => backdrop.remove()); // Clean up any leftover backdrops
  }, [location]);

  useEffect(() => {
    // Check if the user is logged in, for example by checking localStorage
    const token = getAccesstoken();
    setIsLoggedIn(!!token); // Set to true if token exists, false otherwise
  }, []);

  useEffect(() => {
    const loadCartItemCount = async () => {
      if (access_token && user_id) {
        const count = await getCartItemCount(access_token, user_id, baseUrl);
        setCartCount(count);
      }
    };

    // Poll every 2 seconds to update the cart count
    const intervalId = setInterval(loadCartItemCount, 2000);

    // Initial load
    loadCartItemCount();

    // Cleanup on component unmount
    return () => clearInterval(intervalId);
  }, [access_token, user_id, baseUrl]);

  useEffect(() => {
    // Initialize Bootstrap dropdowns for mobile
    const dropdownElements = document.querySelectorAll(".dropdown-toggle");
    dropdownElements.forEach((dropdownElement) => {
      dropdownElement.addEventListener("click", (e) => {
        e.preventDefault();
        const dropdownMenu = dropdownElement.nextElementSibling;
        if (dropdownMenu) {
          const isOpen = dropdownMenu.classList.contains("show");
          document.querySelectorAll(".dropdown-menu.show").forEach((menu) => {
            menu.classList.remove("show");
          });
          if (!isOpen) {
            dropdownMenu.classList.add("show");
          }
        }
      });
    });

    document.addEventListener("click", (e) => {
      if (!e.target.closest(".dropdown")) {
        document.querySelectorAll(".dropdown-menu.show").forEach((menu) => {
          menu.classList.remove("show");
        });
      }
    });

    return () => {
      dropdownElements.forEach((dropdownElement) => {
        dropdownElement.removeEventListener("click", () => { });
      });
    };
  }, []);

  return (
    <div>
      <header className=" pb-0">
        <div className="top-nav top-header sticky-header">
          <div className="container-fluid-lg">
            <div className="row">
              <div className="col-12">
                <div className="navbar-top">
                  <button
                    className="navbar-toggler d-xl-none d-inline navbar-menu-button"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#primaryMenu"
                  >
                    <span className="navbar-toggler-icon me-2">
                      <i className="fa-solid fa-bars"></i>
                    </span>
                  </button>
                  <Link
                    href="/"
                    className="web-logo nav-logo logohiegth"
                    to="/"
                  >
                    <img
                      src={ReducarbLogo}
                      className="img-fluid blur-up lazyload"
                      alt=""
                    />
                  </Link>
                  <div className="header-nav-middle">
                    <div className="main-nav navbar navbar-expand-xl navbar-light navbar-sticky">
                      <div
                        className="offcanvas offcanvas-collapse order-xl-2"
                        id="primaryMenu"
                      >
                        <div className="offcanvas-header navbar-shadow">
                          <h5 className="h5-menu">Menu</h5>
                          <button
                            className="btn-close lead"
                            type="button"
                            data-bs-dismiss="offcanvas"
                          ></button>
                        </div>
                        <div className="offcanvas-body">
                          <ul className="navbar-nav">
                            <li className="nav-item ">
                              <Link
                                className="nav-link no-before font-xsm"
                                to="/"
                              >
                                Home
                              </Link>
                            </li>
                            <li className="nav-item dropdown">
                              <Link
                                className="nav-link  no-before font-xsm"
                                to="/about"
                              >
                                About Us
                              </Link>
                            </li>
                            <li className="nav-item dropdown">
                              <a
                                className="nav-link dropdown-toggle font-xsm"
                                data-bs-toggle="dropdown"
                              >
                                Know Your Reducarb
                              </a>
                              <ul className="dropdown-menu">
                                <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="/reducarb-blends/:blendName"
                                  >
                                    Reducarb Blends
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="/reducarb-variants/:blendName"
                                  >
                                    Reducarb Variants
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="/ready-reckoner"
                                  >
                                    Ready Reckoner
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="/faq"
                                  >
                                    FAQ's
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li className="nav-item dropdown">
                              <Link
                                className="nav-link no-before font-xsm"
                                to="/reducarb-benefit"
                              >
                                Reducarb Benefits
                              </Link>
                            </li>
                            <li className="nav-item dropdown">
                              <a
                                className="nav-link dropdown-toggle font-xsm"
                                data-bs-toggle="dropdown"
                              >
                                Resources
                              </a>
                              <ul className="dropdown-menu">
                                <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="/calculators"
                                    onClick={() => window.location.href = "/calculators"}
                                  >
                                    Calculators
                                  </Link>
                                </li>
                                {/* <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="/podcasts"
                                  >
                                    Podcasts
                                  </Link>
                                </li> */}
                                {/* <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="/pre-diabetes"
                                  >
                                    Prediabetes
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="/abdominal-obesity"
                                  >
                                    Abdominal Obesity
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="risk-heart-disease"
                                  >
                                    Risk of Heart Disease
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item font-xsm "
                                    to="/unhealthy"
                                  >
                                    Unhealthy Dietary Habits
                                  </Link>
                                </li> */}
                              </ul>
                            </li>
                            {/* <li className="nav-item dropdown">
                              <a
                                className="nav-link dropdown-toggle font-xsm"
                                data-bs-toggle="dropdown"
                              >
                                Ecosystem
                              </a>
                              <ul className="dropdown-menu">
                                <li>
                                  <Link
                                    className="dropdown-item font-xsm"
                                    to="/reducarb-blends/:blendName"
                                  >
                                    Reducarb Blends
                                  </Link>
                                </li>
                              </ul>
                            </li> */}
                            <li className="nav-item dropdown font-xsm">
                              <Link
                                className="nav-link  no-before"
                                to="/shop"
                              >
                                Shop
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="rightside-box">
                    <div className="search-full"></div>
                    <ul className="right-side-menu">
                      <li className="right-side d-block">
                        <div className="onhover-dropdown header-badge">
                          <Link to="/cart">
                            <button
                              type="button"
                              className="btn p-0 position-relative header-wishlist"
                            >
                              <i className="fas fa-shopping-cart font-size-nav-icons"></i>
                              <span className="position-absolute top-0 start-100 translate-middle badge">{cartCount}</span>
                            </button>
                          </Link>
                        </div>
                      </li>
                      <li className="right-side onhover-dropdown">
                        <div className="delivery-login-box">
                          <div className="delivery-icon">
                            <i className="fas fa-user font-size-nav-icons me-3"></i>
                          </div>
                          {/* <div className="delivery-detail">
                            <h6>Hello,</h6>
                            <h5>My Account</h5>
                          </div> */}
                        </div>

                        <div className="onhover-div onhover-div-login">
                          <ul className="user-box-name">
                            {!isLoggedIn && (
                              <>
                                <li className="product-box-contain">
                                  <a href="login">Log In</a>
                                </li>
                                <li className="product-box-contain">
                                  <a href="sign-up">Sign Up</a>
                                </li>
                                <li className="product-box-contain">
                                  <a href="forgot-password">Forgot Password</a>
                                </li>
                              </>
                            )}
                            {isLoggedIn && (
                              <div>


                                {/* <li className="product-box-contain">
                                  <Link to={'user/dashboard'}>
                                    Dashboard
                                  </Link>
                                </li> */}
                                <li className="product-box-contain">
                                  <Link to='user/profile'>
                                    Profile
                                  </Link>
                                </li>
                                <li className="product-box-contain">
                                  <a href="#" onClick={logout}>
                                    Logout
                                  </a>
                                </li>
                              </div>
                            )}
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
